import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Home } from './components/Home';
import { QRCodeGenerator } from './components/QRCodeGenerator';
import { QRScanner } from './components/QRScanner';
import { ImageCompressor } from './components/ImageCompressor';
import { BackgroundRemover } from './components/BackgroundRemover';
import { BarcodeGenerator } from './components/BarcodeGenerator';
import { KeyGenerator } from './components/KeyGenerator';
import { GradientGenerator } from './components/GradientGenerator';
import { YoutubeDownloader } from './components/YoutubeDownloader';
import { YoutubeVideoDownloader } from './components/YoutubeVideoDownloader';
import { YoutubeTitleGenerator } from './components/YoutubeTitleGenerator';
import { FormatConverter } from './components/FormatConverter';
import { PdfUtilities } from './components/PdfUtilities';
import { ImageResizerCropper } from './components/ImageResizerCropper';
import { ImageColorPicker } from './components/ImageColorPicker';
import { PhotoCollageMaker } from './components/PhotoCollageMaker';
import { AudioWorkshop } from './components/AudioWorkshop';
import { CodeMinifier } from './components/CodeMinifier';
import { TextToSpeech } from './components/TextToSpeech';
import { LoanCalculator } from './components/LoanCalculator';
import { MetaTagGenerator } from './components/MetaTagGenerator';
import { OpenGraphGenerator } from './components/OpenGraphGenerator';
import { RobotsTxtGenerator } from './components/RobotsTxtGenerator';
import { SitemapGenerator } from './components/SitemapGenerator';
import { YoutubeTagGenerator } from './components/YoutubeTagGenerator';
import { HashtagGenerator } from './components/HashtagGenerator';
import { KeywordDensityChecker } from './components/KeywordDensityChecker';
import { SEOAnalyzer } from './components/SEOAnalyzer';
import { BacklinkChecker } from './components/BacklinkChecker';
import { GoogleIndexChecker } from './components/GoogleIndexChecker';
import { AgeCalculator } from './components/AgeCalculator';
import { BMICalculator } from './components/BMICalculator';
import { CurrencyConverter } from './components/CurrencyConverter';
import { UnitConverter } from './components/UnitConverter';
import { TimeZoneConverter } from './components/TimeZoneConverter';
import { InternetSpeedTest } from './components/InternetSpeedTest';
import { Stopwatch } from './components/Stopwatch';
import { CountdownTimer } from './components/CountdownTimer';
import { RandomPickerWheel } from './components/RandomPickerWheel';
import { CalendarGenerator } from './components/CalendarGenerator';
import { PrivacyPolicy } from './components/PrivacyPolicy';
import { TermsConditions } from './components/TermsConditions';
import { AboutUs } from './components/AboutUs';
import { Blog } from './components/Blog';
import { BlogPost } from './components/BlogPost';
import { OrganizationSchema, WebSiteSchema } from './seo';
import { ScrollToTop } from './components/ScrollToTop';
import { TopBannerAd } from './components/TopBannerAd';
import { AdBlockGuard } from './components/AdBlockGuard';
import './App.css';

function App() {
  return (
    <Router>
      {/* AdBlock Overlay Guard */}
      <AdBlockGuard />
      
      {/* Global Structured Data */}
      <OrganizationSchema />
      <WebSiteSchema />
      <ScrollToTop />
      
      <div className="App" style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <Header />
        <main style={{ flex: '1 0 auto', padding: '0 24px 40px', background: 'var(--bg-secondary)', boxSizing: 'border-box' }}>
          <TopBannerAd />
          <div style={{ paddingTop: '32px' }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/qrcode-generator" element={<QRCodeGenerator />} />
            <Route path="/qr-scanner" element={<QRScanner />} />
            <Route path="/image-compressor" element={<ImageCompressor />} />
            <Route path="/remove-background" element={<BackgroundRemover />} />
            <Route path="/barcode-generator" element={<BarcodeGenerator />} />
            <Route path="/key-generator" element={<KeyGenerator />} />
            <Route path="/gradient-generator" element={<GradientGenerator />} />
            <Route path="/youtube-downloader" element={<YoutubeDownloader />} />
            <Route path="/youtube-video-downloader" element={<YoutubeVideoDownloader />} />
            <Route path="/youtube-title-generator" element={<YoutubeTitleGenerator />} />
            <Route path="/format-converter" element={<FormatConverter />} />
            <Route path="/pdf-utilities" element={<PdfUtilities />} />
            <Route path="/pdf-utilities/:toolId" element={<PdfUtilities />} />
            <Route path="/pdf-utilities-:toolSlug" element={<PdfUtilities />} />
            <Route path="/image-workshop" element={<ImageResizerCropper />} />
            <Route path="/image-color-picker" element={<ImageColorPicker />} />
            <Route path="/photo-collage" element={<PhotoCollageMaker />} />
            <Route path="/audio-workshop" element={<AudioWorkshop />} />
            <Route path="/audio-workshop/:toolId" element={<AudioWorkshop />} />
            <Route path="/audio-workshop-:toolSlug" element={<AudioWorkshop />} />
            <Route path="/code-minifier" element={<CodeMinifier />} />
            <Route path="/text-to-speech" element={<TextToSpeech />} />
            <Route path="/loan-calculator" element={<LoanCalculator />} />
            <Route path="/meta-tag-generator" element={<MetaTagGenerator />} />
            <Route path="/open-graph-generator" element={<OpenGraphGenerator />} />
            <Route path="/robots-txt-generator" element={<RobotsTxtGenerator />} />
            <Route path="/sitemap-generator" element={<SitemapGenerator />} />
            <Route path="/youtube-tag-generator" element={<YoutubeTagGenerator />} />
            <Route path="/hashtag-generator" element={<HashtagGenerator />} />
            <Route path="/keyword-density-checker" element={<KeywordDensityChecker />} />
            <Route path="/seo-analyzer" element={<SEOAnalyzer />} />
            <Route path="/backlink-checker" element={<BacklinkChecker />} />
            <Route path="/google-index-checker" element={<GoogleIndexChecker />} />
            <Route path="/age-calculator" element={<AgeCalculator />} />
            <Route path="/bmi-calculator" element={<BMICalculator />} />
            <Route path="/currency-converter" element={<CurrencyConverter />} />
            <Route path="/unit-converter" element={<UnitConverter />} />
            <Route path="/time-zone-converter" element={<TimeZoneConverter />} />
            <Route path="/internet-speed-test" element={<InternetSpeedTest />} />
            <Route path="/stopwatch" element={<Stopwatch />} />
            <Route path="/countdown-timer" element={<CountdownTimer />} />
            <Route path="/random-picker-wheel" element={<RandomPickerWheel />} />
            <Route path="/calendar-generator" element={<CalendarGenerator />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsConditions />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
          </Routes>
          </div>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
